module.exports = __webpack_public_path__ + "media/images/iconSocialX--dark-14314528c58fa731fffefec1f638981a.png";